import { APICompsSchema } from "@/apis/api-config";
import { CorpFeedV2Item, CorpReelV2Item, CorpStoryV2Item } from "@/apis/connect/corporate-api";

import { SAMPLE_MEDIA_IMAGE, SAMPLE_PROFILE_IMAGE } from "./sample-media";

/**
 * HINOMEエンタープライズ（アカウント横断分析）のデモ用サンプルデータ
 *
 * デモアカウントでログインしたときだけ使う。実データは一切参照しない。
 * 架空の店舗アカウントを横断分析している体で構成する。
 */
type SimpleInstagramAccount = APICompsSchema["CorpSimpleInstagramTableResponse"];
type InstagramAccountWithSubscription = APICompsSchema["InstagramAccountWithSubscriptionSchema"];

const TIMESTAMP = "2026-08-20T09:00:00+09:00";

const baseAccount = {
  firebase_user_id: "sample-corp-user",
  // Layout が未連携扱いにして画面を止めないよう、ダミー値を入れる（実トークンではない）
  non_limit_facebook_token: "sample-token",
  profile_picture_url: SAMPLE_PROFILE_IMAGE,
  token_active: true,
  insights_denied: false,
  created_at: "2026-01-10T10:00:00+09:00",
  updated_at: TIMESTAMP,
  label: [],
};

export const SAMPLE_CORPORATE_ACCOUNTS: SimpleInstagramAccount[] = [
  {
    ...baseAccount,
    id: "sample-corp-account-0001",
    instagram_business_id: "sample-corp-ig-0001",
    account_name: "sample_shop_shinjuku",
    display_name: "サンプルショップ 新宿店",
    biograph: "デモ用の架空アカウントです",
    facebook_page_name: "サンプルショップ 新宿店",
    recent_followers_count: 24380,
    now_month_followers_count: 24380,
    prev_month_followers_count: 23120,
    recent_follows_count: 412,
    recent_media_count: 918,
    recent_reach_count: 186400,
    recent_impressions_count: 241800,
    recent_profile_views_count: 12840,
    recent_website_clicks_count: 1860,
    recent_views_count: 264500,
    recent_total_interactions_count: 18420,
    recent_accounts_engaged_count: 9640,
    recent_likes_count: 14820,
    recent_comments_count: 1260,
    recent_saves_count: 1840,
    recent_shares_count: 500,
    recent_insight_timestamp: TIMESTAMP,
  },
  {
    ...baseAccount,
    id: "sample-corp-account-0002",
    instagram_business_id: "sample-corp-ig-0002",
    account_name: "sample_shop_umeda",
    display_name: "サンプルショップ 梅田店",
    biograph: "デモ用の架空アカウントです",
    facebook_page_name: "サンプルショップ 梅田店",
    recent_followers_count: 18620,
    now_month_followers_count: 18620,
    prev_month_followers_count: 18040,
    recent_follows_count: 386,
    recent_media_count: 742,
    recent_reach_count: 142300,
    recent_impressions_count: 178600,
    recent_profile_views_count: 9420,
    recent_website_clicks_count: 1240,
    recent_views_count: 198200,
    recent_total_interactions_count: 13840,
    recent_accounts_engaged_count: 7260,
    recent_likes_count: 11240,
    recent_comments_count: 940,
    recent_saves_count: 1320,
    recent_shares_count: 340,
    recent_insight_timestamp: TIMESTAMP,
  },
  {
    ...baseAccount,
    id: "sample-corp-account-0003",
    instagram_business_id: "sample-corp-ig-0003",
    account_name: "sample_shop_sapporo",
    display_name: "サンプルショップ 札幌店",
    biograph: "デモ用の架空アカウントです",
    facebook_page_name: "サンプルショップ 札幌店",
    recent_followers_count: 9840,
    now_month_followers_count: 9840,
    prev_month_followers_count: 10120,
    recent_follows_count: 524,
    recent_media_count: 486,
    recent_reach_count: 68400,
    recent_impressions_count: 84200,
    recent_profile_views_count: 4820,
    recent_website_clicks_count: 610,
    recent_views_count: 92400,
    recent_total_interactions_count: 6240,
    recent_accounts_engaged_count: 3480,
    recent_likes_count: 5120,
    recent_comments_count: 420,
    recent_saves_count: 560,
    recent_shares_count: 140,
    recent_insight_timestamp: TIMESTAMP,
  },
  {
    ...baseAccount,
    id: "sample-corp-account-0004",
    instagram_business_id: "sample-corp-ig-0004",
    account_name: "sample_shop_fukuoka",
    display_name: "サンプルショップ 福岡店",
    biograph: "デモ用の架空アカウントです",
    facebook_page_name: "サンプルショップ 福岡店",
    recent_followers_count: 13260,
    now_month_followers_count: 13260,
    prev_month_followers_count: 12480,
    recent_follows_count: 298,
    recent_media_count: 604,
    recent_reach_count: 104800,
    recent_impressions_count: 132400,
    recent_profile_views_count: 7180,
    recent_website_clicks_count: 940,
    recent_views_count: 146800,
    recent_total_interactions_count: 9860,
    recent_accounts_engaged_count: 5240,
    recent_likes_count: 8020,
    recent_comments_count: 680,
    recent_saves_count: 940,
    recent_shares_count: 220,
    recent_insight_timestamp: TIMESTAMP,
  },
  {
    ...baseAccount,
    id: "sample-corp-account-0005",
    instagram_business_id: "sample-corp-ig-0005",
    account_name: "sample_shop_nagoya",
    display_name: "サンプルショップ 名古屋店",
    biograph: "デモ用の架空アカウントです",
    facebook_page_name: "サンプルショップ 名古屋店",
    recent_followers_count: 16040,
    now_month_followers_count: 16040,
    prev_month_followers_count: 15380,
    recent_follows_count: 342,
    recent_media_count: 688,
    recent_reach_count: 121600,
    recent_impressions_count: 154200,
    recent_profile_views_count: 8240,
    recent_website_clicks_count: 1080,
    recent_views_count: 168400,
    recent_total_interactions_count: 11420,
    recent_accounts_engaged_count: 6180,
    recent_likes_count: 9280,
    recent_comments_count: 780,
    recent_saves_count: 1080,
    recent_shares_count: 280,
    recent_insight_timestamp: TIMESTAMP,
  },
  {
    ...baseAccount,
    id: "sample-corp-account-0006",
    instagram_business_id: "sample-corp-ig-0006",
    account_name: "sample_shop_online",
    display_name: "サンプルショップ オンライン",
    biograph: "デモ用の架空アカウントです",
    facebook_page_name: "サンプルショップ オンライン",
    recent_followers_count: 31480,
    now_month_followers_count: 31480,
    prev_month_followers_count: 29640,
    recent_follows_count: 208,
    recent_media_count: 1246,
    recent_reach_count: 248200,
    recent_impressions_count: 318600,
    recent_profile_views_count: 18640,
    recent_website_clicks_count: 4120,
    recent_views_count: 362800,
    recent_total_interactions_count: 24680,
    recent_accounts_engaged_count: 13240,
    recent_likes_count: 19840,
    recent_comments_count: 1680,
    recent_saves_count: 2460,
    recent_shares_count: 700,
    recent_insight_timestamp: TIMESTAMP,
  },
];

/**
 * デモモードで instagramAccountInfoAtom に流し込む代表アカウント
 * デモ組織にはInstagramアカウントを紐づけないため、ここで補う
 */
export const SAMPLE_CORPORATE_INSTAGRAM_ACCOUNT: InstagramAccountWithSubscription = {
  firebase_user_id: baseAccount.firebase_user_id,
  non_limit_facebook_token: "sample-token",
  instagram_business_id: "sample-corp-ig-0001",
  facebook_page_name: "サンプルショップ 新宿店",
  account_name: "sample_shop_shinjuku",
  display_name: "サンプルショップ 新宿店",
  biograph: "デモ用の架空アカウントです",
  profile_picture_url: SAMPLE_PROFILE_IMAGE,
  token_active: true,
  insights_denied: false,
  id: "sample-corp-account-0001",
  created_at: baseAccount.created_at,
  updated_at: TIMESTAMP,
};

type CorporateTableAccount = APICompsSchema["CorpInstagramTableResponse"];
type CorporateAccountListResponse = APICompsSchema["FirestoreInstagramAccountListResponse"];

/** アカウント一覧（v2）用。投稿本数などの集計をサンプルアカウントの規模から作る */
export const SAMPLE_CORPORATE_TABLE_ACCOUNTS: CorporateTableAccount[] = SAMPLE_CORPORATE_ACCOUNTS.map(
  (account, index) => {
    const nowFeed = 8 + index;
    const nowReel = 4 + (index % 3);
    const nowStory = 12 + index * 2;
    const prevFeed = 7 + (index % 4);
    const prevReel = 3 + (index % 2);
    const prevStory = 10 + index;
    return {
      ...account,
      within_period_post_count: nowFeed + nowReel,
      now_month_post_count: nowFeed + nowReel + nowStory,
      prev_month_post_count: prevFeed + prevReel + prevStory,
      now_month_feed_count: nowFeed,
      now_month_reel_count: nowReel,
      now_month_story_count: nowStory,
      prev_month_feed_count: prevFeed,
      prev_month_reel_count: prevReel,
      prev_month_story_count: prevStory,
      benchmark_account_count: 3 + (index % 3),
    };
  },
);

export const SAMPLE_CORPORATE_ACCOUNT_LIST_RESPONSE: CorporateAccountListResponse = {
  items: SAMPLE_CORPORATE_TABLE_ACCOUNTS,
  pagination: {
    has_next: false,
    page_size: SAMPLE_CORPORATE_TABLE_ACCOUNTS.length,
    total_count: SAMPLE_CORPORATE_TABLE_ACCOUNTS.length,
  },
};

const POST_TIMESTAMPS = [
  "2026-08-19T12:00:00+09:00",
  "2026-08-16T18:30:00+09:00",
  "2026-08-13T09:15:00+09:00",
  "2026-08-09T20:00:00+09:00",
  "2026-08-05T11:40:00+09:00",
  "2026-08-01T15:20:00+09:00",
];

const accountRef = (index: number) => {
  const account = SAMPLE_CORPORATE_ACCOUNTS[index % SAMPLE_CORPORATE_ACCOUNTS.length];
  return {
    instagram_business_id: account.instagram_business_id,
    account_name: account.account_name,
    display_name: account.display_name ?? account.account_name,
    profile_picture_url: account.profile_picture_url,
  };
};

export const SAMPLE_CORPORATE_FEED_ITEMS: CorpFeedV2Item[] = POST_TIMESTAMPS.map((timestamp, index) => {
  const reach = 12400 - index * 1200;
  const like = 820 - index * 60;
  const comment = 64 - index * 5;
  const saved = 180 - index * 14;
  const engagement = like + comment + saved;
  return {
    ...accountRef(index),
    media_id: `sample-corp-feed-${index + 1}`,
    captions: "【サンプル】店舗の新作アイテムをご紹介します。",
    media_url: SAMPLE_MEDIA_IMAGE,
    permalink: "",
    timestamp,
    recent_like_count: like,
    recent_comment_count: comment,
    recent_engagement_count: engagement,
    recent_impression_count: Math.round(reach * 1.28),
    recent_reach_count: reach,
    recent_saved_count: saved,
    recent_video_view_count: 0,
    recent_share_count: 42 - index * 4,
    recent_follows_count: 18 - index,
    recent_engagement_ratio_by_reach: Number(((engagement / reach) * 100).toFixed(2)),
    recent_engagement_ratio_by_follower: Number(((engagement / 18420) * 100).toFixed(2)),
    recent_engagement_ratio_by_imp: Number(((engagement / (reach * 1.28)) * 100).toFixed(2)),
    recent_profile_activity_bio_link_clicked: 24 - index * 2,
    recent_profile_activity_call: 0,
    recent_profile_activity_direction: 6 - index,
    recent_profile_activity_email: 0,
    recent_profile_activity_text: 0,
    recent_profile_activity_other: 0,
    recent_insight_updated_at: TIMESTAMP,
    synced_at: TIMESTAMP,
  };
});

export const SAMPLE_CORPORATE_REEL_ITEMS: CorpReelV2Item[] = POST_TIMESTAMPS.map((timestamp, index) => {
  const reach = 28600 - index * 2400;
  const like = 1480 - index * 120;
  const comment = 118 - index * 9;
  const saved = 384 - index * 28;
  const engagement = like + comment + saved;
  return {
    ...accountRef(index + 1),
    media_id: `sample-corp-reel-${index + 1}`,
    captions: "【サンプル】スタッフおすすめの使い方をリールにまとめました。",
    media_url: SAMPLE_MEDIA_IMAGE,
    permalink: "",
    timestamp,
    recent_play_count: 42800 - index * 3600,
    recent_avg_watch_time: 8600 - index * 400,
    recent_video_view_total_time: 368000 - index * 24000,
    recent_like_count: like,
    recent_comment_count: comment,
    recent_engagement_count: engagement,
    recent_reach_count: reach,
    recent_saved_count: saved,
    recent_share_count: 146 - index * 12,
    recent_engagement_ratio_by_reach: Number(((engagement / reach) * 100).toFixed(2)),
  };
});

export const SAMPLE_CORPORATE_STORY_ITEMS: CorpStoryV2Item[] = POST_TIMESTAMPS.map((timestamp, index) => {
  const reach = 6800 - index * 520;
  return {
    ...accountRef(index + 2),
    media_id: `sample-corp-story-${index + 1}`,
    media_url: SAMPLE_MEDIA_IMAGE,
    permalink: "",
    timestamp,
    recent_impression_count: Math.round(reach * 1.16),
    recent_reach_count: reach,
    recent_follows_count: 12 - index,
    recent_navigation_count: 940 - index * 80,
    recent_profile_activity_count: 68 - index * 5,
    recent_profile_visits_count: 142 - index * 11,
    recent_shares_count: 24 - index * 2,
    recent_total_interactions_count: 186 - index * 14,
  };
});

type CorporateTopWorstMedia = APICompsSchema["CorpTopWorstMediaResponse"];
type CorporateTopWorstItem = APICompsSchema["CorpTopWorstMediaItem"];

const toTopWorstItem = (item: CorpFeedV2Item, mediaType: string, playCount?: number): CorporateTopWorstItem => ({
  media_id: item.media_id,
  instagram_business_id: item.instagram_business_id,
  account_name: item.account_name,
  profile_picture_url: item.profile_picture_url ?? SAMPLE_PROFILE_IMAGE,
  media_type: mediaType,
  timestamp: item.timestamp,
  captions: item.captions,
  media_url: item.media_url,
  permalink: item.permalink,
  like_count: item.recent_like_count,
  comment_count: item.recent_comment_count,
  engagement_count: item.recent_engagement_count,
  reach_count: item.recent_reach_count,
  saved_count: item.recent_saved_count,
  play_count: playCount,
});

export const SAMPLE_CORPORATE_TOP_WORST_MEDIA: CorporateTopWorstMedia = {
  feed_top: SAMPLE_CORPORATE_FEED_ITEMS.slice(0, 3).map((item) => toTopWorstItem(item, "IMAGE")),
  feed_worst: SAMPLE_CORPORATE_FEED_ITEMS.slice(-3)
    .reverse()
    .map((item) => toTopWorstItem(item, "IMAGE")),
  reel_top: SAMPLE_CORPORATE_REEL_ITEMS.slice(0, 3).map((item, index) =>
    toTopWorstItem(
      {
        ...SAMPLE_CORPORATE_FEED_ITEMS[index],
        media_id: item.media_id,
        instagram_business_id: item.instagram_business_id,
        account_name: item.account_name,
        display_name: item.display_name,
        profile_picture_url: item.profile_picture_url,
        captions: item.captions,
        timestamp: item.timestamp,
        recent_like_count: item.recent_like_count,
        recent_comment_count: item.recent_comment_count,
        recent_engagement_count: item.recent_engagement_count,
        recent_reach_count: item.recent_reach_count,
        recent_saved_count: item.recent_saved_count,
      },
      "VIDEO",
      item.recent_play_count,
    ),
  ),
  reel_worst: SAMPLE_CORPORATE_REEL_ITEMS.slice(-3)
    .reverse()
    .map((item, index) =>
      toTopWorstItem(
        {
          ...SAMPLE_CORPORATE_FEED_ITEMS[index],
          media_id: item.media_id,
          instagram_business_id: item.instagram_business_id,
          account_name: item.account_name,
          display_name: item.display_name,
          profile_picture_url: item.profile_picture_url,
          captions: item.captions,
          timestamp: item.timestamp,
          recent_like_count: item.recent_like_count,
          recent_comment_count: item.recent_comment_count,
          recent_engagement_count: item.recent_engagement_count,
          recent_reach_count: item.recent_reach_count,
          recent_saved_count: item.recent_saved_count,
        },
        "VIDEO",
        item.recent_play_count,
      ),
    ),
};

type CorporateInsightResponse = APICompsSchema["CorpInstagramInsightResponse"];
type CorporateInsightPoint = APICompsSchema["CorpInsightOneComps"];

/** サンプル時系列の日数。実行日に依存しないよう固定の終端日から遡る */
const INSIGHT_DAYS = 30;
const INSIGHT_END_DATE = "2026-08-20";

const insightDates = (): string[] => {
  const end = new Date(`${INSIGHT_END_DATE}T00:00:00+09:00`);
  return Array.from({ length: INSIGHT_DAYS }, (_, index) => {
    const day = new Date(end);
    day.setDate(end.getDate() - (INSIGHT_DAYS - 1 - index));
    return day.toISOString().slice(0, 10);
  });
};

/**
 * アカウントごとの時系列を作る
 * 実行のたびに数値が変わると混乱するため、乱数は使わず日付インデックスから決定的に生成する
 */
const buildSeries = (
  pick: (account: SimpleInstagramAccount) => number,
  dailyGrowthRate: number,
): CorporateInsightPoint[] =>
  insightDates().map((date, dayIndex) => {
    const targetCount: { [key: string]: number } = {};
    SAMPLE_CORPORATE_ACCOUNTS.forEach((account, accountIndex) => {
      const base = pick(account);
      const trend = 1 - dailyGrowthRate * (INSIGHT_DAYS - 1 - dayIndex);
      // 曜日ごとの山谷を再現する固定の揺らぎ
      const wave = 1 + 0.04 * Math.sin((dayIndex + accountIndex) / 2);
      targetCount[account.instagram_business_id] = Math.round(base * trend * wave);
    });
    return { target_count: targetCount, created_at: date };
  });

export const SAMPLE_CORPORATE_INSIGHT: CorporateInsightResponse = {
  account_name: SAMPLE_CORPORATE_ACCOUNTS.reduce<{ [key: string]: string }>((acc, account) => {
    acc[account.instagram_business_id] = account.display_name ?? account.account_name;
    return acc;
  }, {}),
  followers_count_list: buildSeries((a) => a.recent_followers_count, 0.0018),
  impression_count_list: buildSeries((a) => Math.round(a.recent_impressions_count / INSIGHT_DAYS), 0.0022),
  reach_count_list: buildSeries((a) => Math.round(a.recent_reach_count / INSIGHT_DAYS), 0.0022),
  profile_views: buildSeries((a) => Math.round(a.recent_profile_views_count / INSIGHT_DAYS), 0.0025),
  website_clicks: buildSeries((a) => Math.round(a.recent_website_clicks_count / INSIGHT_DAYS), 0.0028),
  corp_account_hint_msg: [],
};

type CorporateOrganization = APICompsSchema["OrganizationSchema"];
type CorporateMember = APICompsSchema["CorpMemberResponse"];

/** デモ組織。DBには作らず、フロント側だけで完結させる */
type CorporateMembership = APICompsSchema["OrganizationMembershipSchema"];
type CorporateOrgMember = APICompsSchema["OrganizationMemberResponse"];
type CorporateInvitation = APICompsSchema["OrganizationInvitationResponse"];
type CorporateOrgInstagramAccount = APICompsSchema["OrgInstagramAccountSchema"];

export const SAMPLE_CORPORATE_ORGANIZATION: CorporateOrganization = {
  id: "sample-organization",
  company_name: "サンプル株式会社",
  company_url: "",
  memo: "HINOMEエンタープライズのデモ環境です",
  created_at: baseAccount.created_at,
  updated_at: TIMESTAMP,
};

/**
 * デモのログインユーザー
 * デモは実データを一切参照しないため、users / organizations の投入は不要にしている
 */
/** デモの所属組織。1組織・オーナーで全ての操作を見せる */
export const SAMPLE_CORPORATE_MEMBERSHIPS: CorporateMembership[] = [
  {
    organization_id: SAMPLE_CORPORATE_ORGANIZATION.id,
    company_name: SAMPLE_CORPORATE_ORGANIZATION.company_name,
    company_url: SAMPLE_CORPORATE_ORGANIZATION.company_url,
    role: "owner",
    joined_at: "2026-01-10T10:00:00+09:00",
  },
];

export const SAMPLE_CORPORATE_MEMBERS: CorporateOrgMember[] = [
  {
    firebase_auth_user_id: "sample-corp-user-0001",
    user_id: "sample-corp-user-0001",
    email: "owner@example.com",
    last_name: "サンプル",
    first_name: "太郎",
    full_name: "サンプル 太郎",
    role: "owner",
    joined_at: "2026-01-10T10:00:00+09:00",
    recent_login_date: TIMESTAMP,
    instagram_account_count: 6,
    is_self: true,
  },
  {
    firebase_auth_user_id: "sample-corp-user-0002",
    user_id: "sample-corp-user-0002",
    email: "shinjuku@example.com",
    last_name: "サンプル",
    first_name: "花子",
    full_name: "サンプル 花子",
    role: "admin",
    joined_at: "2026-02-01T10:00:00+09:00",
    recent_login_date: TIMESTAMP,
    instagram_account_count: 2,
    is_self: false,
  },
  {
    firebase_auth_user_id: "sample-corp-user-0003",
    user_id: "sample-corp-user-0003",
    email: "umeda@example.com",
    last_name: "サンプル",
    first_name: "次郎",
    full_name: "サンプル 次郎",
    role: "viewer",
    joined_at: "2026-03-01T10:00:00+09:00",
    recent_login_date: null,
    instagram_account_count: 0,
    is_self: false,
  },
];

export const SAMPLE_CORPORATE_INVITATIONS: CorporateInvitation[] = [
  {
    id: "sample-invitation-0001",
    organization_id: SAMPLE_CORPORATE_ORGANIZATION.id,
    email: "invited@example.com",
    role: "viewer",
    status: "pending",
    expires_at: "2026-12-31T23:59:59+09:00",
    invited_by_name: "サンプル 太郎",
    accepted_at: null,
    revoked_at: null,
    created_at: TIMESTAMP,
    updated_at: TIMESTAMP,
    debug_url: null,
  },
  {
    id: "sample-invitation-0002",
    organization_id: SAMPLE_CORPORATE_ORGANIZATION.id,
    email: "expired@example.com",
    role: "admin",
    status: "expired",
    expires_at: "2026-01-31T23:59:59+09:00",
    invited_by_name: "サンプル 太郎",
    accepted_at: null,
    revoked_at: null,
    created_at: "2026-01-24T10:00:00+09:00",
    updated_at: "2026-01-24T10:00:00+09:00",
    debug_url: null,
  },
];

export const SAMPLE_CORPORATE_ORG_INSTAGRAM_ACCOUNTS: CorporateOrgInstagramAccount[] =
  SAMPLE_CORPORATE_ACCOUNTS.map((account) => ({
    id: account.id,
    instagram_business_id: account.instagram_business_id,
    account_name: account.account_name,
    display_name: account.display_name,
    profile_picture_url: account.profile_picture_url,
    biograph: account.biograph,
    assigned_at: "2026-01-10T10:00:00+09:00",
    linked_user_names: ["サンプル 太郎"],
  }));

export const sampleCorporateMember = (email: string): CorporateMember => ({
  id: "sample-corp-user-0001",
  firebase_auth_user_id: "sample-corp-user-0001",
  email,
  last_name: "サンプル",
  first_name: "太郎",
  company_name: SAMPLE_CORPORATE_ORGANIZATION.company_name,
  job_category: "マーケティング",
  industry_category: "小売",
  birthday: "1990-01-01",
  gender: "none",
  phone_number: "03-0000-0000",
  facebook_id: "",
  favorite_instagram_account: SAMPLE_CORPORATE_INSTAGRAM_ACCOUNT.instagram_business_id,
  token_status: true,
  is_admin: false,
  created_at: baseAccount.created_at,
  updated_at: TIMESTAMP,
  instagram_accounts: [SAMPLE_CORPORATE_INSTAGRAM_ACCOUNT],
  organizations: SAMPLE_CORPORATE_MEMBERSHIPS,
});
